import React from "react";
import { Navigate, Route, Routes } from "react-router";
import "./App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
// import "@fontsource/space-grotesk";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import LoadinIcon from "./Layout/loadingIcon";
import AutoUpdateToken from "./services/Account/AutoUpdateToken";
import sessionStorageContext from "./components/context/LocalStorageContext";
import TransactionsPaymentDetails from "./components/Partner/Transactions/TransactionPaymentDetails";
import SanctionsProgram from "./components/Partner/Compliance/SanctionsProgram";
import LocalStorageProvider from "./components/Provider/LocalStorageProvider";
import Compliance from "./components/Partner/Compliance/Compliance";
// import ComplianceTab from "./components/AdminTabcontent/ComplianceTab";
import ComplainceTab from "./components/Partner/Compliances/ComplianceTab";
import AllCountry from "./components/AllCountry/AllCountry";
import { ROUTES } from "./constants/frontendPaths";
import ForgotPassword from "./components/Account/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/Account/ResetPassword/ResetPassword";
import FraudScreen from "./components/Partner/FraudScreen/FraudScreen";
import { UnsavedChangesProvider } from "./components/context/UnsavedChangesContext";
import InvoicePartnerList from "./components/Invoice/InvoicePartnerList/InvoicePartnerList";
import InvoicePartnerTabs from "./components/Invoice/InvoicePartnerTabs/InvoicePartnerTabs";
import InvoiceCreatorProfile from "./components/Invoice/InvoiceCreatorProfile/InvoiceCreatorProfile";
import InvoiceList from "./components/Invoice/InvoiceList/InvoiceList";
import InvoiceUserList from "./components/Invoice/InvoiceUserList/InvoiceUserList";
import InvoiceApprove from "./components/Invoice/InvoicePartnerTabs/InvoiceApprove";
import CreatorServices from "./components/Invoice/InvoicePartnerTabs/CreatorServices";
import Payers from "./components/Invoice/InvoicePartnerTabs/Payers";
import ReferrerList from "./components/Invoice/ReferrerList/ReferrerList";
import ReferUserList from "./components/Invoice/ReferUserList/ReferUserList";
const PaymentInfo = React.lazy(() => import("./components/PartnerOnboardReady/Payment/PaymentInfo"));
const Payout = React.lazy(() => import("./components/PartnerOnboardReady/Payout/Payout"));
const ViewTransaction = React.lazy(() => import("./components/PartnerOnboardReady/ViewTransaction/ViewTransaction"));
const UserInformation = React.lazy(() => import("./components/PartnerOnboardReady/UserInformation/UserInformation"));
const Profile = React.lazy(() => import("./components/Account/Profile/Profile"));
const Layout = React.lazy(() => import("./Layout/Layout"));
const AdminTab = React.lazy(() => import("./components/AdminTabcontent/AdminTab"));
const InstrailsFees = React.lazy(() => import("./components/AdminTabcontent/InstrailsFees"));
const PartnerTable = React.lazy(() => import("./components/Partner/PartnerTable/PartnerTable"));
const UserManagement = React.lazy(() => import("./components/Users/UserManagement"));
const Details = React.lazy(() => import("./Layout/Details"));
const Login = React.lazy(() => import("./components/Account/Login/Login"));
const Payment = React.lazy(() => import("./Layout/Payment"));
const Paymentsettingread = React.lazy(() => import("./components/Partner/PaymentReadonly/Paymentsettingread"));
const Dashboard = React.lazy(() => import("./Layout/Dashboard"));
const CountyManagement = React.lazy(() => import("./components/CountryMaster/CountyManagement"));
const AgentManagement = React.lazy(() => import("./components/AgentMaster/AgentManagement"));
const FraudRiskConfiguration = React.lazy(() => import("./components/FraudRiskConfiguration/FraudRiskConfiguration"));
const PartnerLimits = React.lazy(() => import("./components/PartnerLimits/PartnerLimits"));
const DropdownList = React.lazy(() => import("./components/Dropdowns/DropdownList"));
const UpdateQuote = React.lazy(() => import("./components/UpdateQuote/UpdateQuote"));
const SwirepayPaymentsList = React.lazy(() => import("./components/Invoice/SwirepayPaymentsList/SwirepayPaymentsList"));
const SanctionVendorPriority = React.lazy(() => import("./components/SanctionVendorPriority/SanctionVendorPriority"));

export default function App() {
	return (
		<BrowserRouter>
			<LocalStorageProvider>
				<UnsavedChangesProvider>
				<AutoUpdateToken />
				<Routes>
					<Route
						path={ROUTES.ROOT}
						element={
							<Suspense>
								<Login />
							</Suspense>
						}
					/>
					<Route path={ROUTES.LOGIN} element={<Navigate to={ROUTES.ROOT} />} />
					<Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
					<Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
					<Route path={ROUTES.ADMIN.ROOT} element={<Layout />}>
						<Route index element={<Details />} />
						<Route
							path={ROUTES.ADMIN.MANAGE_PARTNER_LIMITS}
							element={
								<Suspense>
									<PartnerLimits/>
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.MANAGE_DROPDOWNS}
							element={
								<Suspense>
									<DropdownList/>
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.MANAGE_QUOTE}
							element={
								<Suspense>
									<UpdateQuote/>
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.MANAGE_SANCTION_VENDORS}
							element={
								<Suspense>
									<SanctionVendorPriority/>
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.PARTNER_DETAILS}
							element={
								<Suspense>
									<Details />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.PARTNER_PAYMENT}
							element={
								<Suspense>
									<Payment />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.USER_MANAGEMENT}
							element={
								<Suspense>
									<UserManagement />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.COUNTY_MASTER}
							element={
								<Suspense>
									<CountyManagement />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.AGENT_MASTER}
							element={
								<Suspense>
									<AgentManagement />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.ALL_COUNTRY}
							element={
								<Suspense>
									<AllCountry />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.FRAUD_RISK_CONFIGURATION}
							element={
								<Suspense>
									<FraudRiskConfiguration />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.COMPLIANCE}
							element={
								<Suspense>
									<ComplainceTab />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.FRAUD_SCREEN}
							element={
								<Suspense>
									<FraudScreen />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.DASHBOARD}
							element={
								<Suspense>
									<Dashboard />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.PARTNER}
							element={
								<Suspense>
									<PartnerTable />
								</Suspense>
							}
						/>
							<Route
							path={ROUTES.ADMIN.INVOICE_PARTNER}
							element={
								<Suspense>
									<InvoicePartnerList/>
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.INVOICES}
							element={
								<Suspense>
									<InvoiceList />
								</Suspense>
							}
						/>

						<Route
							path={ROUTES.ADMIN.REFERRER}
							element={
								<Suspense>
									<ReferrerList/>
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.REFER_USERS}
							element={
								<Suspense>
									<ReferUserList/>
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.TRANSACTION_DETAILS}
							element={
								<Suspense>
									<TransactionsPaymentDetails />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.INVOICE_USER}
							element={
								<Suspense>
									<InvoiceUserList />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.INVOICE_CREATOR_PROFILE}
							element={
								<Suspense>
									<InvoiceCreatorProfile />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.INVOICE_PARTNER_TABS}
							element={
								<Suspense>
									<InvoicePartnerTabs />
									</Suspense>
								}
							>
								<Route
									path="payers"
									element={
										<Suspense>
											<Payers />
										</Suspense>
									}
								/>
								<Route
									path="services"
									element={
										<Suspense>
											<CreatorServices />
										</Suspense>
									}
								/>
								<Route
									path="approve"
									element={
										<Suspense>
											<InvoiceApprove />
										</Suspense>
									}
								/>
						</Route>
							
						<Route
							path={ROUTES.ADMIN.PARTNER_ADMIN}
							element={
								<Suspense>
									<AdminTab />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.PARTNER_ADMIN_FEES}
							element={
								<Suspense>
									<InstrailsFees />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.PARTNER_ADMIN_USERINFO}
							element={
								<Suspense>
									<UserInformation />
								</Suspense>
							}
						/>
						<Route
							path={ROUTES.ADMIN.SWIREPAY_PAYMENTS}
							element={
								<Suspense>
									<SwirepayPaymentsList/>
								</Suspense>
							}
						/>
					</Route>

					<Route
						path="*"
						element={
							<Suspense>
								<PageNotFound />
							</Suspense>
						}
					/>
					<Route
						path={ROUTES.PAYMENT_INFO}
						element={
							<Suspense>
								<PaymentInfo />
							</Suspense>
						}
					/>
					<Route
						path={ROUTES.PAYOUT}
						element={
							<Suspense>
								<Payout />
							</Suspense>
						}
					/>
					<Route
						path={ROUTES.VIEW_TRANSACTION}
						element={
							<Suspense>
								<ViewTransaction />
							</Suspense>
						}
					/>
					<Route
						path={ROUTES.PROFILE}
						element={
							<Suspense>
								<Profile />
							</Suspense>
						}
					/>
					<Route
						path={ROUTES.TRANSACTION_DETAILS}
						element={
							<Suspense>
								<TransactionsPaymentDetails />
							</Suspense>
						}
					/>
					<Route
						path={ROUTES.SANCTIONS_PROGRAM}
						element={
							<Suspense>
								<SanctionsProgram />
							</Suspense>
						}
					/>
				</Routes>
			</UnsavedChangesProvider>
			</LocalStorageProvider>
		</BrowserRouter>
	);
}

function PageNotFound() {
	return (
		<div>
			<h2>404 Page not found</h2>
		</div>
	);
}
